var innerRemote;
function attachRemote (resolve) {
	if(__webpack_require__.m[72273]) {
		innerRemote = __webpack_require__(72273);
	}
	var gs = __webpack_require__.g || globalThis
	gs["transportation"] = innerRemote
	if(resolve) resolve(innerRemote);
	return innerRemote;
};
__webpack_require__.federation.attachRemote = attachRemote;
attachRemote();